module.exports = __webpack_public_path__ + "media/images/flags/ne-6ae76a66067996ce0b9efc490f0c4439.svg";